
import * as __star__ from '@ckeditor/ckeditor5-typing/dist/index.js';

const {

Delete,
DeleteCommand,
Input,
InsertTextCommand,
TextTransformation,
TextWatcher,
TwoStepCaretMovement,
Typing,
TypingChangeBuffer,
_DeleteObserver,
findAttributeRange,
findAttributeRangeBound,
getLastTextLine,
inlineHighlight,
__esModule
} = __star__;

export {
Delete,
DeleteCommand,
Input,
InsertTextCommand,
TextTransformation,
TextWatcher,
TwoStepCaretMovement,
Typing,
TypingChangeBuffer,
_DeleteObserver,
findAttributeRange,
findAttributeRangeBound,
getLastTextLine,
inlineHighlight,
__esModule
};

